import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Receipt, Download, FilePdf } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function MyReceiptsPage() {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const inv = await axios.get(`${API}/api/my/invoices`).catch(() => ({ data: [] }));
        setInvoices(Array.isArray(inv.data) ? inv.data : []);
      } catch {
        toast.error('Erro a carregar faturas');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="fade-in max-w-xl mx-auto" data-testid="my-receipts-page">
      <h1 className="font-heading text-2xl text-brand-text mb-1">As minhas faturas</h1>
      <p className="text-xs text-brand-muted mb-5">Faturas das tuas consultas.</p>

      {loading ? (
        <p className="text-xs text-brand-muted text-center py-10">A carregar...</p>
      ) : invoices.length === 0 ? (
        <div className="bg-white border border-brand-border rounded-2xl p-8 text-center" data-testid="receipts-empty">
          <Receipt size={32} className="mx-auto text-brand-placeholder mb-2" weight="duotone" />
          <p className="text-xs text-brand-muted">Ainda não há faturas.</p>
        </div>
      ) : (
        <div className="space-y-6">
          {invoices.length > 0 && (
            <div data-testid="invoices-list">
              <h2 className="text-xs font-semibold text-brand-muted uppercase tracking-wider mb-2">Faturas</h2>
              <ul className="space-y-2">
                {invoices.map((inv) => (
                  <li key={inv.id} className="bg-white border border-brand-border rounded-2xl p-3 flex items-center gap-3" data-testid={`invoice-${inv.id}`}>
                    <div className="w-9 h-9 rounded-full bg-brand-green/15 flex items-center justify-center flex-shrink-0">
                      <FilePdf size={14} className="text-brand-green" weight="duotone" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-brand-text truncate">{inv.filename}</p>
                      <p className="text-[10px] text-brand-muted">{inv.invoice_date}</p>
                    </div>
                    <a
                      href={`${API}/api/invoices/${inv.id}/pdf`}
                      target="_blank"
                      rel="noreferrer"
                      className="bg-brand-green text-white rounded-full px-3 py-1.5 text-xs font-medium flex items-center gap-1"
                      data-testid={`invoice-download-${inv.id}`}
                    >
                      <Download size={12} /> PDF
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
